import React, { useContext, useState, useEffect } from 'react';
import ChartsTree from 'partials/charts-tree';
import Chart from 'core/ui/charts/index';
import SessionContext from 'SessionContext';

const ChartFinder = (props) => {
  const context = useContext(SessionContext);
  const chartsStore = context.chartsStore;
  const findPathToFirstLeafNode = chartsStore.findPathToFirstLeafNode;
  const pathIsInTaxonomy = chartsStore.pathIsInTaxonomy;

  const [selectedNodePath, setSelectedNodePath] = useState(undefined);

  useEffect(() => {
    props.hasUpdated?.();
    // eslint-disable-next-line
  }, [props.hasUpdated]);

  const onChartClick = (chart_id, ev) => {
     ev?.stopPropagation();
    props.onClickChart && props.onClickChart(chart_id);
  };

  const onSelectNode = (path) => {
    setSelectedNodePath(path);
  };

  if (!chartsStore.loaded) return <span>Loading...</span>;
  let taxonomy = props.searchTerm
    ? chartsStore.filteredTaxonomy(new RegExp(`\\b${props.searchTerm}`, 'i'))
    : chartsStore.taxonomy;

  const validSelectedNodePath = pathIsInTaxonomy(selectedNodePath, taxonomy)
    ? selectedNodePath
    : findPathToFirstLeafNode(taxonomy);

  const selectedNodeDirs = validSelectedNodePath.slice();
  const selectedNode = selectedNodeDirs.pop();
  let liClass = '';
  if (validSelectedNodePath[0] === 'My Files') {
    liClass = 'up-customers';
  }

  const checkIfLocationType = (val) => val.includes('location_type');

  const addWidgetsToRails = (chart_id) => {
    return (
      <div className="add-widgets">
        {!props.isComplex && !checkIfLocationType(chart_id) && (
          <div className="add-filter" onClick={() => props.onAddToFilters(chart_id)}>
            <i className="fa-solid fa-arrow-left" />
            Add to Filters
          </div>
        )}
        <div className="add-insight" onClick={() => props.onAddToInsights(chart_id)}>
          <i className="fa-solid fa-arrow-right" />
          Add to Insights
        </div>
      </div>
    );
  }

  let recent_title = "Recently Used";
  let hasRecents = taxonomy[1][recent_title];
  let recent_charts = hasRecents !== undefined ? { [recent_title]: JSON.parse(JSON.stringify(hasRecents)) } : {};
  let all_charts = Object.keys(taxonomy[1]).reduce((acc, key) => {
    if (key !== recent_title) {
      acc[key] = taxonomy[1][key];
    }
    return acc;
  }, {});

  return (
    <div className="chart-finder">
      <div className="taxonomy-rail">
        <h3>Data Groups</h3>
        <div className="taxonomy-list">
          {hasRecents && (
            <>
              <ChartsTree
                taxonomy={recent_charts}
                onSelectNode={onSelectNode}
                selectedNodePath={validSelectedNodePath}
              />
              <hr />
            </>
          )}
          <ChartsTree
            taxonomy={all_charts}
            onSelectNode={onSelectNode}
            selectedNodePath={validSelectedNodePath}
          />
        </div>
      </div>

      <div className="charts-rail">
        <h3>
          {selectedNodeDirs.map((d, i) => (
            <em key={i}>{d} &gt;</em>
          ))}{" "}
          {selectedNode}
        </h3>

        <ul className="charts-list">
          {chartsStore.getChartIdsAtNodePath(validSelectedNodePath, taxonomy).map((chart_id) => (
            <li className={chart_id === "persontype" ? "persontype" : liClass} key={chart_id}>
              <Chart
                chart_id={chart_id}
                crossfilter={false}
                viewOnly
                loaded={true}
                addWidgetsToRails={() => addWidgetsToRails(chart_id)}
                onClick={onChartClick}
              >
                {chart_id !== "counts" && chart_id !== "count" && ( // REMOVE WHEN ALL ARE CONVERTED TO FUNCTIONAL
                  addWidgetsToRails(chart_id)
                )}
              </Chart>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ChartFinder;
